





import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'MobileScreen'
})
export default class MobileScreen extends Vue {

}
